module.exports = __webpack_public_path__ + "img/locked-icon.1100c8ab.svg";